// .dat文件编辑器页面

import React, { useState } from 'react';
import { Drawer, Button, Flex, Result } from 'antd';
import { CloseOutlined } from "@ant-design/icons";

import DraggerPage from './DraggerPage';
import DecodePage from './DecodePage';

const DatFileEditorPage = ({ isMobile, datFileEditorShow, onClose }) => {
    // 是否展示页面
    const [showPage, setShowPage] = useState(isMobile ? false : true);
    // 文件
    const [file, setFile] = useState(null);
    // 当前页面标号，拖拽文件0，解析文件1
    const [currentStep, setCurrentStep] = useState(0);

    // 跳转到解析页面
    const goToDecodePage = () => {
        setCurrentStep(1);
    }

    // 返回到拖拽页面
    const backToDraggerPage = () => {
        setFile(null);
        setCurrentStep(0);
    }

    return (
        <Drawer title='.dat文件编辑器' placement='left' width={isMobile ? '100%' : '85%'} open={datFileEditorShow}
            closeIcon={null}
            extra={<Button type='text' icon={<CloseOutlined style={{ color: '#808080' }} />} size='large'
                onClick={onClose} />}>
            {showPage && <Flex justify='flex-start' align='center' vertical='true' style={{ height: '100%', width: '100%' }}>
                <div style={{ flex: 1, width: '80%' }}>
                    {currentStep === 0 && <DraggerPage setFile={setFile} goToDecodePage={goToDecodePage} />}
                    {currentStep === 1 && <DecodePage file={file} backToDraggerPage={backToDraggerPage} />}
                </div>
            </Flex>}
            {isMobile && !showPage && <Result
                status="warning"
                title="提示"
                subTitle="检测到您正在使用移动端设备访问，为了获得更好的体验，请使用电脑或平板进行访问。"
                extra={[
                    <Button key="back" onClick={onClose}>
                        返回
                    </Button>,
                    <Button type="primary" key="console" onClick={() => { setShowPage(true) }}>
                        继续访问
                    </Button>
                ]}
            />}
        </Drawer>
    );
}

export default DatFileEditorPage;